export const getRegularIdSelector = (compId: string) => `#${compId}`
export const getTemplateRepeaterIdSelector = (compId: string) => `[id^="${compId}__"]`
